import React, { Fragment } from "react";
import { Col } from "react-bootstrap";
import Arrow from "../../assets/arrow.png";

const RazonDos = () => {
  return (
    <Fragment>
      <Col lg={6}>
        <h4>Razón #2</h4>
        <h2
          data-aos="fade-left"
          data-aos-offset="300"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          Respaldo de un líder
        </h2>
        <p
          data-aos="fade-left"
          data-aos-offset="300"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          Experiencia de casi tres décadas. Inspirados en nuestros valores.
        </p>
        <p
          data-aos="fade-right"
          data-aos-offset="300"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          <a
            href="https://piscinasipc.com/empresa/"
            target="_blank"
            rel="noreferrer"
          >
            Nuestra Historia <img src={Arrow} alt="Nuestra historia"></img>
          </a>
        </p>
      </Col>
      <Col lg={6}>
        <div
          className="text-center contentMarquee"
          data-aos="zoom-in"
          data-aos-offset="300"
          data-aos-duration="1000"
          data-aos-easing="ease-out"
        >
          <marquee
            bgcolor="transparent"
            width="50%"
            scrolldelay="100"
            scrollamount="5"
            direction="up"
            loop="infinite"
            align="middle"
          >
            <h2>Pasión</h2>
            <h2>Confianza</h2>
            <h2>Innovación</h2>
            <h2>Pasión</h2>
            <h2>Confianza</h2>
            <h2>Innovación</h2>
            <h2>Pasión</h2>
            <h2>Confianza</h2>
            <h2>Innovación</h2>
            <h2>Pasión</h2>
            <h2>Confianza</h2>
            <h2>Innovación</h2>
            <h2>Pasión</h2>
            <h2>Confianza</h2>
            <h2>Innovación</h2>
            <h2>Pasión</h2>
            <h2>Confianza</h2>
            <h2>Innovación</h2>
            <h2>Pasión</h2>
            <h2>Confianza</h2>
            <h2>Innovación</h2>
          </marquee>
          <div id="backRoll"></div>
        </div>
      </Col>
    </Fragment>
  );
};

export default RazonDos;
